import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import { Header } from "../../components/header/Header";
import { ContextApi } from "../../context/contextApi";

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CircularProgress from '@mui/material/CircularProgress';

import styles from './style.module.scss'

export function Login() {
    let navigate = useNavigate()
    const { userLogin, cookies, setLoading, loading, isAuthorization } = useContext(ContextApi)
    const { register, control, handleSubmit, watch, formState: { errors } } = useForm();
    const [visibilityPassword, setVisibilityPassword] = useState(false);

    const onSubmit = data => {
        setLoading(true);
        userLogin({
            email: data.email,
            Password: data.password
        })
    };

    const Input = ({ label, register, required, registerName, type }) => (
        <div className={styles.contentInputs}>
          <label>{label}</label>
          <input type={type} {...register(registerName, { required })} />
        </div>
    );

    const InputPassword = ({ label, register, required, registerName, type }) => (
        <div className={styles.contentInputsPassword}>
          <label>{label}</label>
          <div className={styles.contentPassword}>
            <input type={type} {...register(registerName, { required })} />
            {!visibilityPassword ? <VisibilityOffIcon onClick={() => setVisibilityPassword(!visibilityPassword)} /> : <VisibilityIcon onClick={() => setVisibilityPassword(!visibilityPassword)}/>}
          </div>
        </div>
    );

    useEffect(() => {
        setTimeout(() => {
        if (cookies?.surfViewToken?.token && (cookies?.surfViewToken?.userRole === true || cookies?.surfViewToken?.userRole === "regional")) {
                navigate("/")   
                setLoading(false);             
            }
        }, 2000);
    }, [isAuthorization])

    return (
        <>
            <Header />
            <div className={styles.containerLogin}>
                <div className={styles.contentLogin}>
                    <div className={styles.headerLogin}>
                        <span>
                            Digite seu login e senha para ter acesso
                        </span>
                    </div>
                    <form
                    onSubmit={handleSubmit(onSubmit)}
                    className={styles.formInputLogin}
                    >
                        <Input label="E-mail" registerName="email" register={register} required />
                        <InputPassword label="Senha" type={visibilityPassword ? "text" : "password"} registerName="password" register={register} required />
                        <div className={styles.boxBTNSubmit}>
                            {!loading && <input type="submit" />}
                            {loading && (
                              <CircularProgress />
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}